import service from '../../../service/index';
import ui from '@/ui';

export default {
  creatGlodVIP({
    state
  }) {
    return ui.withLoading(service.freeGoldVIP)();
  }
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/goldFree/store/actions.js